document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('design-now-form-thank-you');
    
    if (form) {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            const formData = new FormData(form);
            
            fetch(form.dataset.zapierAction, {
                method: 'POST',
                body: formData
            })
            .then(response => {
                if (response.ok) {
                    document.querySelectorAll('.custom-rush-form').forEach(el => el.style.display = 'none');
                    document.querySelectorAll('.success-msg').forEach(el => el.style.display = 'block');
                    Cookies.remove('design-customer-email');
                    Cookies.remove('session_id');
                }
            });
        });
    }
    
    const email = Cookies.get('design-customer-email');
    const session_id = Cookies.get('session_id');
    const name = Cookies.get('design-customer-name');
    
    if (email) {
        document.querySelectorAll('.custom-rush-form').forEach(el => el.style.display = 'block');
        
        const emailInput = document.querySelector('.custom-rush-form input[name="rush_email"]');
        const nameInput = document.querySelector('.custom-rush-form input[name="rush_name"]');
        const sessionInput = document.querySelector('.custom-rush-form input[name="session_id"]');
        
        if (emailInput) emailInput.value = email;
        if (nameInput) nameInput.value = name || '';
        if (sessionInput) sessionInput.value = session_id || '';
    }
    
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const smsButton = document.getElementById('custom-form-sms-consent-button');
    if (smsButton) {
        smsButton.setAttribute('href', isMobile 
            ? 'https://emerson-coast.myklpages.com/p/taptotextcoast' 
            : 'https://manage.kmail-lists.com/subscriptions/subscribe?a=TrD6uE&g=X4gBCG'
        );
    }
});